import { Segmented } from 'antd';
import { useState } from 'react';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import AppointmentLookupPage from './AppointmentLookup/AppointmentLookup.page';
import OnboardingPage from './Onboarding/Onboarding.page';

const TAB_APPOINTMENT_LOOKUP = 'Appointment Lookup';
const TAB_ONBOARDING = 'Onboarding';

const segmentedOptions = [
  { label: TAB_APPOINTMENT_LOOKUP, value: TAB_APPOINTMENT_LOOKUP },
  { label: TAB_ONBOARDING, value: TAB_ONBOARDING },
];

const EHRIntegrations = () => {
  const [activeButton, setActiveButton] = useState(() => {
    const stored = getFromStorage('ehrIntegrationsSegment');
    return segmentedOptions.some((o) => o.value === stored)
      ? stored
      : TAB_APPOINTMENT_LOOKUP;
  });

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('ehrIntegrationsSegment', value);
  };

  return (
    <div className="page-wrapper">
      <div className="lg:flex gap-3 justify-between py-3 items-center">
        <Segmented
          options={segmentedOptions}
          value={activeButton}
          onChange={handleSegmentedTabChange}
        />
      </div>
      <div>
        {activeButton === TAB_APPOINTMENT_LOOKUP && <AppointmentLookupPage />}
        {activeButton === TAB_ONBOARDING && <OnboardingPage />}
      </div>
    </div>
  );
};

export default EHRIntegrations;
